function r(t,a,n){return Math.min(Math.max(t,a),n)}export{r as default};
//# sourceMappingURL=clamp.js.map
